import { usePathname } from "next/navigation";

export default function Header(){
    const pathname = usePathname();
    const isPhotographerPage = pathname?.startsWith("/photographer/");

    
}